import React from 'react';
import {
  AttachmentPreviewList,
  LinkPreviewList,
  QuotedMessagePreview,
  SimpleAttachmentSelector,
  useMessageInputContext,
  SendButton,
  CooldownTimer,
  TextareaComposer,
  useChatContext,
} from 'stream-chat-react';
import styles from './CommentBox.module.scss';

import { Thumbnail } from 'design-system-web';

const SendButtonWithCooldown = () => {
  const { handleSubmit, cooldownRemaining, setCooldownRemaining } =
    useMessageInputContext();

  return cooldownRemaining ? (
    <CooldownTimer
      cooldownInterval={cooldownRemaining}
      setCooldownRemaining={setCooldownRemaining}
    />
  ) : (
    <SendButton sendMessage={handleSubmit} />
  );
};

export const CommentBox = () => {
  const { client } = useChatContext();
  const { hideSendButton } = useMessageInputContext();
  const user = client.user;

  return (
    <div className={styles.commentBoxContainer}>
      <div className="mr-1 mt-1" data-testid="thumbnail">
        {user?.name && <Thumbnail name={user.name} />}
      </div>

      <div className="flex items-center w-full">
        <div className={styles.messageInputContainer}>
          <QuotedMessagePreview />
          <LinkPreviewList />
          <AttachmentPreviewList />
          <div className={styles.textareaContainer}>
            <TextareaComposer
              containerClassName="flex w-full"
              className={`${styles.TextArea} `}
              placeholder="Add comment"
            />
            <SimpleAttachmentSelector />
          </div>
        </div>
      </div>

      {!hideSendButton && (
        <div className="flex items-center ml-2 space-x-1">
          <SendButtonWithCooldown />
        </div>
      )}
    </div>
  );
};
